import { render, staticRenderFns } from "./PAWeeklyTasks.vue?vue&type=template&id=59c466fd&scoped=true"
import script from "./PAWeeklyTasks.vue?vue&type=script&lang=js"
export * from "./PAWeeklyTasks.vue?vue&type=script&lang=js"
import style0 from "./PAWeeklyTasks.vue?vue&type=style&index=0&id=59c466fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c466fd",
  null
  
)

export default component.exports